import React from "react";
import { Box, Typography } from "@mui/material";
import ContactForm from "../../../components/contactForm/ContactForm";
import "./ContactFormSection.css";

export default function ContactFormSection() {
  const handleFormSubmit = (data) => {
    console.log("Form submitted:", data);
    // handle API request or email
  };

  return (
    <Box className="contact-form-section">
      <Typography variant="h3" className="contact-section-title">
        Ready to Bring Your Vision to Life?
      </Typography>
      <Typography variant="subtitle1" className="contact-section-subtitle">
        Get a free consultation with our experts and start your project today
      </Typography>

      <Box className="contact-form-wrapper">
        <ContactForm
          buttonText="Get Free Consultation"
          onSubmit={handleFormSubmit}
        />
      </Box>
    </Box>
  );
}
